module.exports = __webpack_public_path__ + "static/media/77.aeec461.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/77.wav
// module id = drGb
// module chunks = 0